const faqFilterForm = document.querySelector('#faqFilter');

if (faqFilterForm) {
	const filterCountEl = faqFilterForm.querySelector('#filterCount');
	const faqResultsContainerEl = document.querySelector('#faqResultsContainer');
	const resetFaqFilterBtn = faqFilterForm.querySelector('#resetFaqilter');

	const filterTagsEls = faqFilterForm.querySelectorAll('.fliter-tags-checkbox');
	const faqCategoryEls = faqResultsContainerEl.querySelectorAll('.faq-category');

	let filterCounter = 0;

	const doSearch = () => {
		const tags = Array.from(faqFilterForm.querySelectorAll('.fliter-tags-checkbox:checked')).map((el) => el.value);

		if (tags.length) {
			faqCategoryEls.forEach((item) => {
				const id = item.getAttribute('id').split('-')[1];
				if (tags.includes(id)) {
					item.classList.remove('hidden');
				} else {
					item.classList.add('hidden');
				}
			});
			resetFaqFilterBtn.classList.remove('md:hidden');
		} else {
			faqCategoryEls.forEach((item) => {
				item.classList.remove('hidden');
			});
			resetFaqFilterBtn.classList.add('md:hidden');
		}
	};

	filterTagsEls.forEach((item) => {
		item.addEventListener('change', (event) => {
			doSearch();

			if (!event.currentTarget.checked && filterCounter > 0) {
				filterCounter -= 1;
			} else {
				filterCounter += 1;
			}
			filterCountEl.innerHTML = `${filterCounter} filters`;
		});
	});

	resetFaqFilterBtn.addEventListener('click', (event) => {
		event.preventDefault();

		filterTagsEls.forEach((item) => {
			if (item.checked) {
				// eslint-disable-next-line no-param-reassign
				item.checked = false;

				if ('createEvent' in document) {
					const evt = document.createEvent('HTMLEvents');
					evt.initEvent('change', false, true);
					item.dispatchEvent(evt);
				} else {
					item.fireEvent('onchange');
				}
			}
		});

		event.target.classList.add('md:hidden');
	});
}
